// @flow
import type { Action } from '../../types';

export const priceListUpdated = (): Action => ({
  type: 'ADMIN_PRICE_LIST_UPDATED'
});
